import { render, staticRenderFns } from "./addEdit.vue?vue&type=template&id=3da87720&scoped=true&"
import script from "./addEdit.vue?vue&type=script&lang=js&"
export * from "./addEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da87720",
  null
  
)

export default component.exports